import { useContext } from "react";
import { HistoricalDataContext } from "./HistoricalDataContext";

export const useHistoricalDataContext = () => useContext(HistoricalDataContext);
